import React from 'react';
import { Filter } from 'lucide-react';
import './MembershipStatusFilter.css';

export type MembershipStatusFilter = 'all' | 'active' | 'deactivated';

interface MembershipStatusFilterProps {
  selectedMembershipStatus: MembershipStatusFilter;
  onMembershipStatusChange: (status: MembershipStatusFilter) => void;
  activeCount: number;
  deactivatedCount: number;
  totalPaidCount: number;
}

const MembershipStatusFilter: React.FC<MembershipStatusFilterProps> = ({
  selectedMembershipStatus,
  onMembershipStatusChange,
  activeCount,
  deactivatedCount,
  totalPaidCount
}) => {
  const membershipOptions = [
    { 
      value: 'all' as MembershipStatusFilter, 
      label: 'Todas las Membresías', 
      count: totalPaidCount,
      className: 'all'
    },
    { 
      value: 'active' as MembershipStatusFilter, 
      label: 'Al Día', 
      count: activeCount,
      className: 'active'
    },
    { 
      value: 'deactivated' as MembershipStatusFilter, 
      label: 'Desactivados', 
      count: deactivatedCount,
      className: 'deactivated'
    }
  ];

  return (
    <div className="membership-status-filter">
      <div className="membership-status-filter-header">
        <Filter size={18} />
        <span>Filtrar por Estado de Membresía:</span>
      </div>
      <div className="membership-status-filter-options">
        {membershipOptions.map((option) => (
          <button
            key={option.value}
            className={`membership-status-filter-button ${option.className} ${
              selectedMembershipStatus === option.value ? 'active' : ''
            }`}
            onClick={() => onMembershipStatusChange(option.value)}
          >
            <span className="membership-status-label">{option.label}</span>
            <span className="membership-status-count">({option.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MembershipStatusFilter;

